// extracted by mini-css-extract-plugin
export default {"contentWrapper":"iGqo4ukTWyVu75jOsux_","notifications":"cwIHthwMbmwa9b7eMHwL","notification":"S0oqn1TazxQC3lFgZbUB"};